// Import model
import { ExternalLinkCondition } from '../models/ExternalLinkCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ExternalLinkIndexedFields } from '../models/ExternalLinkIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ExternalLinkIndexedFieldsSerializer } from './ExternalLinkIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ExternalLinkCondition - handles JSON serialization and deserialization with type validation
 */
export class ExternalLinkConditionSerializer {
  /**
   * Deserializes a JSON string into a ExternalLinkCondition instance
   */
  static deserialize(json: string): ExternalLinkCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ExternalLinkCondition instance
   */
  static fromObject(obj: any): ExternalLinkCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ExternalLinkCondition');
    }


    const instance: ExternalLinkCondition = {
      fieldName: obj['fieldName'] as ExternalLinkIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ExternalLinkCondition instances
   */
  static deserializeArray(json: string): ExternalLinkCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ExternalLinkCondition instance to a JSON string
   */
  static serialize(instance: ExternalLinkCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ExternalLinkCondition instance to a plain object
   */
  static toObject(instance: ExternalLinkCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ExternalLinkCondition instances to a JSON string
   */
  static serializeArray(instances: ExternalLinkCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
